import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";

// Status filter, rendered as a shadcn Select rather than a pill strip - the
// strip overflowed on narrow screens and didn't read as a filter control.
// Same (value, onChange, options) signature as before, so every call site
// (My Requests, My Approvals, Audit Logs) needed no changes.
export default function SegmentedTabs<T extends string>({
  value,
  options,
  onChange,
  className
}: {
  value: T;
  options: { value: T; label: string }[];
  onChange: (value: T) => void;
  className?: string;
}) {
  return (
    <Select value={value} onValueChange={(v) => onChange(v as T)}>
      <SelectTrigger className={className ?? "h-9 w-[11.25rem]"}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((opt) => (
          <SelectItem key={opt.value} value={opt.value}>
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
